package cc.easyandroid.easycompose.mvi.utils

import cc.easyandroid.easycompose.mvi.annotations.MainThread
import cc.easyandroid.easycompose.mvi.utils.internal.AtomicRef
import cc.easyandroid.easycompose.mvi.utils.internal.InternalMviKotlinApi
import cc.easyandroid.easycompose.mvi.utils.internal.atomic
import cc.easyandroid.easycompose.mvi.utils.internal.logE
import kotlin.concurrent.Volatile

@Volatile
var isAssertOnMainThreadEnabled: Boolean = true

@MainThread
fun assertOnMainThread() {
    if (isAssertOnMainThreadEnabled) {
        require(isMainThread()) {
            "Not on Main thread, current thread is: ${getCurrentThreadDescription()}"
        }
    }
}
@OptIn(InternalMviKotlinApi::class)
private val mainThreadIdRef = atomic<MainThreadIdHolder?>(null)

internal expect fun getMainThreadId(): MainThreadId?

internal expect fun isMainThread(mainThreadId: MainThreadId): Boolean

internal expect fun getCurrentThreadDescription(): String

internal fun isMainThread(): Boolean {
    if (!isAssertOnMainThreadEnabled) {
        return true
    }
    @OptIn(InternalMviKotlinApi::class)
    val mainThreadId =
        mainThreadIdRef.initAndGet {
            val id: MainThreadId? = getMainThreadId()
            if (id == null) {
                logE("Main thread id is undefined, main thread assert is disabled")
            }
            MainThreadIdHolder(id)
        }

    return mainThreadId.id?.let(::isMainThread) ?: true
}
@OptIn(InternalMviKotlinApi::class)
private inline fun <T : Any> AtomicRef<T?>.initAndGet(init: () -> T): T {
    while (true) {
        var v: T? = value
        if (v != null) {
            return v
        }

        v = init()
        if (compareAndSet(null, v)) {
            return v
        }
    }
}

internal expect class MainThreadId

private class MainThreadIdHolder(val id: MainThreadId?)
